import {
  GET_CATEGORIES_SUCCESS,
  GET_SUBCATEGORIES_SUCCESS,
} from "../actions/categoryActions";

const initState = {
  categories: [],
  subCategories: [],
  loading: false,
};

const categoryReducer = (state = initState, action) => {
  if (action.type === GET_CATEGORIES_SUCCESS) {
    return {
      ...state,
      categories: action.payload,
      loading: false,
    };
  }
  if (action.type === GET_SUBCATEGORIES_SUCCESS) {
    return {
      ...state,
      subCategories: action.payload,
      loading: false,
    };
  }
  return state;
};

export default categoryReducer;
